export default __webpack_public_path__ + "static/media/digital_wireframe_5.509ceba7.jpg";